import { render, staticRenderFns } from "./ListRStockToNhanh.vue?vue&type=template&id=36ce4a21"
import script from "./ListRStockToNhanh.vue?vue&type=script&lang=js"
export * from "./ListRStockToNhanh.vue?vue&type=script&lang=js"
import style0 from "./ListRStockToNhanh.vue?vue&type=style&index=0&id=36ce4a21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports